import { FunctionComponent } from 'react';
import { InputLabel } from '@mui/material';
import { InfoBox } from 'components/common/InfoBox';

export class LabelProps {
  label: string;
  error?: string;
  infoMessage?: string;
  position?: string;
}

export const Label: FunctionComponent<LabelProps> = ({ label, infoMessage, error, position }) => {
  return (
    <InputLabel error={error?true:false} sx={position==="left"?
      {fontSize: 15, fontWeight: 600, marginTop: "6px", marginRight: "8px", float: "left"}:
      {fontSize: 15, fontWeight: 600}
    }>{label}{infoMessage ? <span style={{ display: 'inline-block', verticalAlign: 'middle' }}><InfoBox helpText={infoMessage} style={{ marginLeft: 10 }} /></span> : <></>}</InputLabel>
  )
}